export const aiMatchedMentors = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "Senior UX Designer",
    company: "Figma",
    domain: "Design",
    expertise: ["UX Research", "Figma", "Design Systems", "Prototyping"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20asian%20woman%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20confident%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor1&orientation=squarish",
    matchScore: 98,
    matchReasons: ["Transitioned from Marketing to UX", "Specializes in portfolio building", "Available on your preferred days"],
    bio: "7 years in UX design. Helped 40+ mentees land design roles at top tech companies. Passionate about career transitions and building strong portfolios.",
    sessions: 142,
    rating: 4.9,
    reviews: 38,
    availability: ["Mon", "Wed", "Fri"],
    responseTime: "< 2 hrs",
    sessionRate: "$80/session",
  },
  {
    id: 2,
    name: "Marcus Williams",
    role: "Staff Engineer",
    company: "Stripe",
    domain: "Engineering",
    expertise: ["React", "TypeScript", "System Design", "Frontend Architecture"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20a%20white%20man%20software%20engineer%20late%2030s%2C%20short%20brown%20hair%20with%20light%20stubble%2C%20warm%20confident%20smile%2C%20soft%20studio%20lighting%2C%20clean%20neutral%20background%2C%20dark%20charcoal%20shirt%2C%20sharp%20focused%20portrait%2C%20high%20quality%20photography&width=400&height=400&seq=marcus-white-headshot-v1&orientation=squarish",
    matchScore: 94,
    matchReasons: ["Specializes in frontend career transitions", "Mentored 20+ career switchers", "Strong system design coaching"],
    bio: "10 years building scalable frontend systems. Passionate about mentoring career switchers into senior engineering roles.",
    sessions: 98,
    rating: 4.8,
    reviews: 27,
    availability: ["Tue", "Thu", "Sat"],
    responseTime: "< 4 hrs",
    sessionRate: "$90/session",
  },
  {
    id: 3,
    name: "Priya Sharma",
    role: "Product Manager",
    company: "Notion",
    domain: "Product",
    expertise: ["Product Strategy", "Roadmapping", "User Research", "Agile"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20indian%20woman%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20intelligent%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor3&orientation=squarish",
    matchScore: 91,
    matchReasons: ["Bridged design thinking with product strategy", "Led product at 3 unicorn startups", "Expert in designer-to-PM transitions"],
    bio: "Led product at 3 unicorn startups. Expert at helping designers and engineers move into PM roles with confidence.",
    sessions: 76,
    rating: 4.9,
    reviews: 21,
    availability: ["Mon", "Tue", "Thu"],
    responseTime: "< 3 hrs",
    sessionRate: "$85/session",
  },
];

export const otherMentors = [
  {
    id: 4,
    name: "James Okafor",
    role: "Engineering Manager",
    company: "Airbnb",
    domain: "Engineering",
    expertise: ["Leadership", "Team Building", "Backend", "Career Growth"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20african%20man%20smiling%20confidently%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20leadership%20presence%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor4&orientation=squarish",
    matchScore: 87,
    bio: "Engineering manager with 12 years of experience. Specializes in helping ICs transition into management roles.",
    sessions: 64,
    rating: 4.7,
    reviews: 19,
    availability: ["Wed", "Fri"],
    responseTime: "< 6 hrs",
    sessionRate: "$95/session",
  },
  {
    id: 5,
    name: "Yuki Tanaka",
    role: "Data Scientist",
    company: "OpenAI",
    domain: "Data & AI",
    expertise: ["Machine Learning", "Python", "NLP", "Data Analysis"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20japanese%20woman%20smiling%20gently%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20thoughtful%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor5&orientation=squarish",
    matchScore: 84,
    bio: "Data scientist at OpenAI. Passionate about making ML accessible and helping people break into AI/ML careers.",
    sessions: 53,
    rating: 4.8,
    reviews: 15,
    availability: ["Mon", "Thu", "Sat"],
    responseTime: "< 5 hrs",
    sessionRate: "$100/session",
  },
  {
    id: 6,
    name: "Carlos Rivera",
    role: "Growth Lead",
    company: "Linear",
    domain: "Marketing",
    expertise: ["Growth Strategy", "SEO", "Analytics", "B2B Marketing"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20hispanic%20man%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20energetic%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor6&orientation=squarish",
    matchScore: 81,
    bio: "Growth lead with experience scaling B2B SaaS from 0 to 1M users. Loves helping marketers think like product managers.",
    sessions: 41,
    rating: 4.6,
    reviews: 12,
    availability: ["Tue", "Wed", "Fri"],
    responseTime: "< 8 hrs",
    sessionRate: "$75/session",
  },
  {
    id: 7,
    name: "Amara Osei",
    role: "UX Researcher",
    company: "Google",
    domain: "Design",
    expertise: ["User Research", "Usability Testing", "Qualitative Methods", "Research Ops"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20african%20woman%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20approachable%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor7&orientation=squarish",
    matchScore: 79,
    bio: "UX Researcher at Google with 8 years of experience. Specializes in mixed-methods research and building research practices from scratch.",
    sessions: 37,
    rating: 4.9,
    reviews: 11,
    availability: ["Mon", "Wed"],
    responseTime: "< 4 hrs",
    sessionRate: "$80/session",
  },
  {
    id: 8,
    name: "Daniel Park",
    role: "iOS Engineer",
    company: "Apple",
    domain: "Engineering",
    expertise: ["Swift", "SwiftUI", "iOS Architecture", "App Store Optimization"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20korean%20man%20smiling%20confidently%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20focused%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor8&orientation=squarish",
    matchScore: 76,
    bio: "iOS engineer at Apple. Helped 25+ developers ship their first apps and land roles at top companies.",
    sessions: 29,
    rating: 4.7,
    reviews: 9,
    availability: ["Thu", "Sat"],
    responseTime: "< 6 hrs",
    sessionRate: "$85/session",
  },
  {
    id: 9,
    name: "Fatima Al-Hassan",
    role: "Startup Founder",
    company: "Stealth",
    domain: "Entrepreneurship",
    expertise: ["Fundraising", "Pitch Decks", "Go-to-Market", "Startup Strategy"],
    photo: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20middle%20eastern%20woman%20smiling%20confidently%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20visionary%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor9&orientation=squarish",
    matchScore: 73,
    bio: "2x founder, raised $8M in seed funding. Mentors aspiring founders on building from 0 to 1 and navigating early-stage challenges.",
    sessions: 22,
    rating: 4.8,
    reviews: 7,
    availability: ["Tue", "Fri"],
    responseTime: "< 12 hrs",
    sessionRate: "$110/session",
  },
];

// Legacy export for smart-match page compatibility
export const mentors = aiMatchedMentors.map((m) => ({
  ...m,
  matchReason: m.matchReasons[0],
  tags: m.expertise,
}));

export const domainOptions = ["All Domains", "Design", "Engineering", "Product", "Data & AI", "Marketing", "Entrepreneurship"];
export const roleOptions = ["All Roles", "Designer", "Engineer", "Product Manager", "Data Scientist", "Manager", "Founder"];
export const expertiseOptions = ["All Expertise", "UX Research", "React", "System Design", "Product Strategy", "Machine Learning", "Leadership", "Growth Strategy"];

export const timeSlotsPerDate: Record<number, string[]> = {
  9:  ["7:00 PM"],
  12: ["12:00 PM", "12:30 PM"],
  14: ["6:30 PM"],
  15: ["7:00 PM", "7:30 PM"],
  17: ["12:00 PM"],
  18: ["6:00 PM", "6:30 PM"],
  21: ["7:00 PM"],
  22: ["12:30 PM", "7:00 PM"],
};

export const timeSlots = ["12:00 PM", "12:30 PM", "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM"];

export const calendarDays = [
  { date: 7, available: false }, { date: 8, available: false },
  { date: 9, available: true },  { date: 10, available: false },
  { date: 11, available: false }, { date: 12, available: true },
  { date: 13, available: false }, { date: 14, available: true },
  { date: 15, available: true },  { date: 16, available: false },
  { date: 17, available: true },  { date: 18, available: true },
  { date: 19, available: false }, { date: 20, available: false },
  { date: 21, available: true },  { date: 22, available: true },
];
